/*
 *
 * analysisAPI.js
 *
 */

import Axios from "axios";

const analysisAPI = {
    fetchByID: async data => await Axios.get(`${window.API_URL}/analysis/get.php?analysisID=${data.analysisID}`),
    fetchAll: async () => await Axios.get(`${window.API_URL}/analysis/get.php`),
    fetchByProject: async data => await Axios.get(`${window.API_URL}/analysis/get.php?projectID=${data.projectID}`),
    analyze: async data => await Axios.post(`${window.API_URL}/analysis/analyze.php`, {
        taskID: data.taskID,
        name: data.name
    }),
    delete: async data => await Axios.post(`${window.API_URL}/analysis/delete.php`, {
        IDs: data.IDs
    })
};

export default analysisAPI;